<template>
  <BaseButton
    v-if="$store.getters.isWedding"
    color="red"
    size="large"
    class="w-full flex items-center justify-center"
    data-test-id="enquiry-form__mobile-enquire-btn"
    @click="submit('request_brochure_button')"
  >
    <TagIcon
      :icon="EmailIcon"
      color="mono-white"
      class="mr-2"
    />

    Request a free brochure
  </BaseButton>

  <BaseButton
    v-else
    color="red"
    size="large"
    class="w-full flex items-center justify-center"
    data-test-id="enquiry-form__mobile-enquire-btn"
    @click="submit($store.state.roomSetupAllowsOP ? 'request_to_book_button' : 'enquire_now_button')"
  >
    {{ $store.state.roomSetupAllowsOP ? 'Request to book' : 'Enquire now' }}
  </BaseButton>
</template>

<script>
import EmailIcon from '@tagvenue/icons/24/line/communication/mail-01.svg';
import { markRaw } from 'vue';

import TagIcon from '@/components/TagIcon.vue';
import BaseButton from '@/components/Ui/Buttons/BaseButton.vue';

export default {
  name: 'MobileStartEnquiryBtn',
  emits: ['click'],
  components: { TagIcon, BaseButton },

  data() {
    return {
      EmailIcon: markRaw(EmailIcon),
    };
  },
  methods: {
    track(element) {
      this.$store.dispatch('trackGA4Interaction', {
        section: 'mobile_widget',
        element,
        value: null,
        interaction: 'click',
      });
    },
    submit(trackingElement) {
      this.$emit('click');
      this.track(trackingElement);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
